import GreyLogo from "@/assets/images/grey-logo.svg";
import { CloseOutlined } from "@ant-design/icons";
import { Modal, ModalProps } from "antd";
import { useRef, useState } from "react";
import { IVideoPlayerRef, VideoPlayer } from "../VideoPlayer";
import styles from "./index.module.css";
interface IProps extends ModalProps {
  src: string;
  prompt?: string;
  showCloseButton?: boolean;
  autoPlay?: boolean;
}

export function VideoPlayerModal(props: IProps) {
  const {
    src,
    prompt,
    showCloseButton = false,
    autoPlay = false,
    onCancel,
    ...modalProps
  } = props;

  const videoPlayerRef = useRef<IVideoPlayerRef>(null);
  // 用于强制重新创建 VideoPlayer 组件，解决第二次打开不自动播放的问题
  const [videoKey, setVideoKey] = useState(0);

  const handleModalCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    // 增加 videoKey 来强制重新创建 VideoPlayer，确保下次打开时能正常自动播放
    if (videoPlayerRef.current) {
      videoPlayerRef.current.pause();
    }
    setVideoKey((prev) => prev + 1);
    onCancel?.(e);
  };

  return (
    <Modal
      centered
      classNames={{ content: styles.content }}
      title={null}
      footer={null}
      closeIcon={null}
      width={780}
      onCancel={handleModalCancel}
      {...modalProps}
    >
      {src && (
        <VideoPlayer
          key={videoKey}
          ref={videoPlayerRef}
          src={src}
          maxHeight={440}
          showToolbar
          autoPlay={autoPlay}
          downloadFilename={`${prompt?.slice(0, 40).trim()}.mp4`}
        />
      )}
      {!src && (
        <div className="w-full h-full flex items-center justify-center aspect-video">
          <GreyLogo />
        </div>
      )}
      {prompt && (
        <div className="p-6 font-medium text-[14px] text-[#4D596C]">
          <b className="text-black">Prompt: </b>
          {prompt}
        </div>
      )}
      {showCloseButton && (
        <button
          type="button"
          aria-label="Close"
          className="fixed top-8 right-8 flex text-white bg-black/10 rounded-full p-3 outline-0 border-0 cursor-pointer transition-all duration-300 ant-image-preview-close"
          onClick={handleModalCancel}
        >
          <CloseOutlined />
        </button>
      )}
    </Modal>
  );
}
